module.exports = __webpack_public_path__ + "static/media/danskeheadline-webfont.7bf070c3.ttf";